export default class GoogleOptimize {
    static getStyleAntiFlicker() {
        return `
            .async-hide {
                opacity: 0 !important;
            }
        `;
    }

    static getScriptAntiFlicker(optaContainerId: string) {
        return `
            (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
            h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
            (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
            })(window,document.documentElement,'async-hide','dataLayer',4000,{'${optaContainerId}':true});
        `;
    }

    static getSrcByOptaContainerId(optaContainerId: string) {
        return `https://www.googleoptimize.com/optimize.js?id=${optaContainerId}`;
    }

    static getOptaContainerId(isBcpTheme: boolean) {
        if (isBcpTheme) {
            return process.env.REACT_APP_OPT_CONTAINER_ID_BCP;
        } else return process.env.REACT_APP_OPT_CONTAINER_ID_DIRECT;
    }
}
